import React, { useState } from 'react';
import { useTable, useFlexLayout, usePagination } from 'react-table';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';

import Spinner from '../../components/Spinner';

import Head from './Head';
import Body from './Body';

import './styles.scss';

const Table = ({ data, columns, totalRowsFromDatabase, totalText, onSort, loadTableData, isTableLoading, userId }) => {
  const { t } = useTranslation();
  const [selectedSort, setSelectedSort] = useState({});

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow, rows } = useTable(
    {
      columns,
      data,
      manualPagination: true,
    },
    useFlexLayout,
    usePagination
  );

  const onSortChange = sort => {
    setSelectedSort(sort);
    onSort(userId, sort);
  };

  const getTotalInfoMessage = () => {
    return (
      <p className={`total-data-info-message ${totalRowsFromDatabase === 0 ? 'hidden' : ''}`}>
        {t('shared.totalData')} {totalText ? totalText : totalRowsFromDatabase}
      </p>
    );
  };

  return (
    <>
      {isTableLoading ? (
        <Spinner tableLoading />
      ) : (
        <>
          {getTotalInfoMessage()}
          <InfiniteScroll
            className="styled-infinity-scroll"
            dataLength={rows.length}
            next={() => loadTableData(selectedSort)}
            hasMore={rows.length < totalRowsFromDatabase}
            hasChildren={true}
            loader={
              rows.length !== totalRowsFromDatabase && (
                <p className="mt-3 d-flex justify-content-center">{t('shared.loading')}</p>
              )
            }
          >
            <div className="main-table" {...getTableProps()}>
              <Head headerGroups={headerGroups} onSort={userId && onSortChange} />
              {totalRowsFromDatabase === 0 ? (
                <div className="message-no-data">{t('shared.noData')}</div>
              ) : (
                <Body page={page} prepareRow={prepareRow} getTableBodyProps={getTableBodyProps} />
              )}
            </div>
          </InfiniteScroll>
        </>
      )}
    </>
  );
};

export default Table;
